import { Tour } from '@/_models/Tour';

export enum ActionTypes {
  DELAY = 'delay',
  DELAY_FLOWBAR = 'delay_flowbar',
  SHOW_ASSET = 'show_asset',
  HIDE_ASSET = 'hide_asset',
  SHOW_SWEEP = 'show_sweep',
  HIDE_SWEEP = 'hide_sweep',
  POSITION_TO = 'position_to',
}

export enum ClickAssetTypes {
  Polygon = 'polygon',
  Tag = 'tag',
  Image = 'image',
  Video = 'video',
  HTML = 'html',
  VsObject = 'vsObject',
  Button = 'button',
}

export type FlowsContainerProps = {
  moveToSweep: any;
  hideElements: any;
  showElements: any;
  showCaseTemp: any;
  showcase: any;
  tags: any;
  setFlowsObjects: any;
  polygons: any;
  vsObjects: any;
  navigationManager: any;
  sweeps: any;
  allSweeps: any;
  currentFloor: any;
  setFlowActive: (val: boolean) => void;
  appState: any;
  flowsProps: any[];
  mainFlow: any;
  flowsVisibleAssets: any;
  tourCustomButton: any;
  flowsMenuMeshComponent: any;
  flowsBarMeshComponent: any;
  vrEventManager: any;
  tour: Tour;
  startFlowFromAsset: number | null;
  setSelectedFlowAsset: (val: Record<string, unknown> | null) => void;
  socket: any;
  isLocked: boolean;
  isRemoteControlled: boolean;
  enableFlowRunOnLaunch?: boolean;
};
